// Libraries
var React = require("react");

// Components
var GenericModal = require("../GenericModal/GenericModal");

// Style
require("./Cta.scss");

class CtaModule extends React.Component {
  constructor(props) {
    super(props);
    this.sendEnquiryContainer = React.createRef();
    this.state = {
      showSendEnquiry: false
    };
  }

  handleFormSubmit(event) {
    event.preventDefault();
    window.location.href = event.target.elements.event.value;
  }

  handleOpenLiveChat() {
    if (window.LC_API) {
      window.LC_API.open_chat_window();
    }
  }

  handleCloseModal() {
    this.setState(
      {
        showSendEnquiry: false
      },
      function () {
        // We need to clear these so Dotdigital forms can be opened again
        delete window.landingpages;
        delete window.__dmProcessedPages;
      }
    );
  }

  handleShowSendEnquiry() {
    this.setState(
      {
        showSendEnquiry: true,
      },
      () => {
        const script = document.createElement("script");
        script.src = this.props.data.sendEnquiryFormUrl;
        this.sendEnquiryContainer.current.appendChild(script);
      }
    );
  }

  render() {
    return (
      <div>
        <div
          className={`c-section c-section--gutter c-section--always-padded c-cta ${
            this.props.data.isPremium ? " c-cta--premium" : ""
          }`}
          id={this.props.data.id}
        >
          <div className="c-cta__inner">
            <div className="c-section__inner">
              <h2 className="c-cta__title">{this.props.data.title}</h2>

              {this.props.data.showForm && this.props.data.experiences.length ? (
                <form className="c-cta__form" onSubmit={this.handleFormSubmit}>
                  <label className="u-visually-hidden">Choose an event</label>
                  <select className="c-cta__select" required name="event">
                    {this.props.data.experiences.map((experience, index) => {
                      return (
                        <option key={index} value={experience.url}>
                          {experience.name}
                        </option>
                      );
                    })}
                  </select>
                  <button
                    type="submit"
                    className={`c-button ${
                      this.props.data.isPremium ? " c-button--premium" : ""
                    }`}
                  >
                    {this.props.data.buttonText}
                  </button>
                </form>
              ) : null}

              {this.props.data.showForm && !this.props.data.experiences.length && this.props.data.defaultTicketUrl ?
                <div className="c-cta__button-only">
                  <a href={this.props.data.defaultTicketUrl}
                    className={`c-button ${
                      this.props.data.isPremium ? " c-button--premium" : ""
                    }`}
                  >
                    {this.props.data.buttonText}
                  </a>
                </div>
              : null}

              <p className="c-cta__message">{this.props.data.contactMessage}</p>
              <p className="c-cta__phone-number-container">
                <a
                  href={`tel:${this.props.data.phoneNumber}`}
                  className="c-cta__phone-number"
                >
                  {this.props.data.phoneNumber}
                </a>
              </p>
              <ul className="c-cta__list">
                <li className="c-cta__list-item">
                  <button
                    type="button"
                    className="c-cta__button"
                    onClick={this.handleOpenLiveChat.bind(this)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="74"
                      height="78.704"
                      viewBox="0 0 74 78.704"
                      className="c-cta__icon c-cta__icon--message"
                    >
                      <defs>
                        <clipPath id="messagePath">
                          <path
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            d="M0 0h74v78.704H0z"
                          />
                        </clipPath>
                      </defs>
                      <g clipPath="url(#messagePath)">
                        <path
                          d="M37.604 31.994a3.653 3.653 0 1 1-3.653 3.653 3.653 3.653 0 0 1 3.653-3.653M49.823 31.994a3.653 3.653 0 1 1-3.653 3.653 3.653 3.653 0 0 1 3.653-3.653M25.384 31.994a3.653 3.653 0 1 1-3.653 3.653 3.653 3.653 0 0 1 3.653-3.653"
                          fill="currentColor"
                        />
                        <path
                          d="M70.333 36.544A33.108 33.108 0 0 0 37 3.667a33.117 33.117 0 0 0-33.307 31.86c-.01.34-.026 1.017-.026 1.017s.015.609.024.913a32.449 32.449 0 0 0 7.317 19.659v.025c-.006.042-.021.079-.025.123L9.705 73.067a1.683 1.683 0 0 0 .015.273 1.267 1.267 0 0 0 .147.627c.005.012.006.026.012.037.018.039.045.073.067.11a1.721 1.721 0 0 0 .172.257c.027.033.057.062.086.093a1.828 1.828 0 0 0 .239.214c.027.02.054.041.083.06a1.811 1.811 0 0 0 .359.186l.016.008a1.857 1.857 0 0 0 .413.095c.037 0 .074 0 .111.005a1.8 1.8 0 0 0 .336-.012c.037 0 .072-.008.109-.016a1.815 1.815 0 0 0 .441-.138l14.333-6.814a1.808 1.808 0 0 0 .266-.172 33.546 33.546 0 0 0 4.65 1.094l.125.022c.492.078.989.142 1.489.2.094.01.187.025.281.035.458.048.92.081 1.384.111.131.008.26.022.392.029q.812.041 1.635.043h.135q.862 0 1.713-.043a33.08 33.08 0 0 0 31.619-32.827Z"
                          fill="none"
                          stroke="currentColor"
                          strokeMiterlimit="10"
                          strokeWidth="2.5"
                        />
                      </g>
                    </svg>
                    <span className="c-cta__button-text">Chat with us</span>
                  </button>
                </li>
                <li className="c-cta__list-item">
                  <button
                    type="button"
                    className="c-cta__button"
                    onClick={this.handleShowSendEnquiry.bind(this)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="76"
                      height="51.572"
                      viewBox="0 0 76 51.572"
                      className="c-cta__icon c-cta__icon--email"
                    >
                      <g fill="none" stroke="currentColor" strokeWidth="2">
                        <rect width="76" height="51.571" rx="5" stroke="none" />
                        <rect x="1" y="1" width="74" height="49.571" rx="4" />
                      </g>
                      <path
                        d="m8.5 13.294 29.4 16.953 30.009-16.953"
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                      />
                    </svg>
                    <span className="c-cta__button-text">Send enquiry</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {this.state.showSendEnquiry ? (
          <GenericModal
            isOpen={this.state.showSendEnquiry}
            onCancel={this.handleCloseModal.bind(this)}
            isPremium={this.props.data.isPremium}
            closeAccessibilityText="form popup"
          >
            <div className="c-cta__modal">
              <div ref={this.sendEnquiryContainer}></div>
            </div>
          </GenericModal>
        ) : null}
      </div>
    );
  }
}

module.exports = CtaModule;



// WEBPACK FOOTER //
// ./src/components/Cta/Cta.js